export default __webpack_public_path__ + "static/media/Wheat.0c499926.PNG";